module.exports = __webpack_public_path__ + "static/img/head_pic.a32bb9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/head_pic.png
// module id = n6zP
// module chunks = 1